/*----------------------------------
- NEWSLETTER GATEWAY CONTRACT
----------------------------------*/

/**
 * Website gateway in front of `Product.Newsletter.Subscribe`. It owns the
 * honeypot, the submission-timing check and the per-address throttle, so the
 * public controller rarely sees an unfiltered browser request. It is a filter,
 * not a boundary: the Product action is public too, so it keeps its own source
 * narrowing and write ceiling for callers that never come through here.
 *
 * The literal lives here rather than in the shared package because the route
 * compiler only accepts app-local static path expressions.
 */
export const NEWSLETTER_SUBSCRIBE_GATEWAY_PATH = '/api/website/newsletter/subscribe';
